module.exports = __webpack_public_path__ + "img/platform_vertue.e2c6ec85.png";